const detectInitialDarkMode = () => {
  try {
    if (document.body && document.body.classList.contains('usecore-mvf-dark')) return true;
    const savedTheme = window.localStorage && window.localStorage.getItem('theme');
    if (savedTheme === 'dark') return true;
    if (savedTheme === 'light') return false;
    return Boolean(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);
  } catch (e) {
    return false;
  }
};

const initialState = {
  agents: [],
  currentAgent: null,
  loading: false,
  error: null,

  conversations: [],
  conversationsLoading: false,
  conversationsError: null,

  searchTerm: '',
  filterStatus: 'all',

  isMobileOpen: false,
  isCollapsed: false,
  activeView: 'hub',
  isDarkMode: detectInitialDarkMode(),

  messages: [],
  messagesLoading: false,
  messagesError: null,
  inputMessage: '',
  isTyping: false,
  currentSessionId: null,
  streamingMessage: null,

  wsConnected: false,
  wsConnecting: false,
  wsError: null,

  artifacts: [],
  artifactPanelOpen: false,
  selectedArtifactIdentifier: null,
  artifactsEnabled: false,
};

export default initialState;
